import styled from 'styled-components';
import OutSourcing from './sub/OutSourcing';
import Automation from './sub/Automation';
import BlackBox from './sub/BlackBox';
import WhiteBox from './sub/WhiteBox';
import PerfomTest from './sub/PerfomTest';
import APITest from './sub/APITest';
import SlideBanner from '../../components/SlideBanner';

const Service = styled.div`  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #ffffff;
`;

const ContentSection = styled.div`
  width: 100%;
  // padding: 0 5%;
  // max-width: 1920px;
  background-color: #ffffff;
`;

const ServicePresesnter = ({
  dataList,
  _setServiceType,
  serviceType,
}) => {
  return (
    <Service>
      {/* <SlideSection datas={dataList} type={serviceType} callbackFunc={_setServiceType} /> */}
      <SlideBanner datas={dataList} type={serviceType} callbackFunc={_setServiceType} />
      <ContentSection>
        {serviceType === "outsourcing" ?
          <OutSourcing />
        : serviceType === "automation" ?
          <Automation />
        : serviceType === "blackbox" ?
          <BlackBox />
        : serviceType === "whitebox" ?
          <WhiteBox />
        : serviceType === "api" ?
          <APITest />
        : serviceType === "perfomance" ?
          <PerfomTest />
        : null
        }
      </ContentSection>
    </Service>
  );
};

export default ServicePresesnter;